import React from 'react';

type PencilIconProps = {
  className?: string;
  style?: React.CSSProperties;
};

export function PencilIcon({ className = '', style }: PencilIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      style={style}
    >
      <path
        d="M17.7808 1.75684C16.5088 0.715823 14.5537 0.858403 13.3306 2.08008L3.07765 12.334C2.75734 12.6533 2.51906 13.0508 2.38869 13.4844L1.00441 18.0684C0.924333 18.333 0.996603 18.6201 1.19191 18.8154C1.33449 18.958 1.52638 19.0352 1.72218 19.0352C1.79445 19.0352 1.86769 19.0244 1.93898 19.0029L6.5215 17.6191C6.95509 17.4893 7.35304 17.251 7.67238 16.9307C7.67238 16.9307 17.8408 6.76268 18.0279 6.57518C18.6758 5.92772 19.021 5.03026 18.9756 4.11522C18.9297 3.20018 18.4941 2.33985 17.7808 1.75684ZM2.84474 17.1631L3.82472 13.917C3.85188 13.8267 3.89186 13.7412 3.93849 13.6597L6.34718 16.0689C6.26564 16.1153 6.18 16.1553 6.08937 16.1826L2.84474 17.1631ZM16.9663 5.51563C16.8116 5.67115 9.86647 12.6157 7.44087 15.0415L4.96626 12.5664L14.3911 3.14062C14.7774 2.7539 15.2871 2.55468 15.7808 2.55468C16.1616 2.55468 16.5332 2.67382 16.8311 2.91698C17.2227 3.23827 17.4522 3.68944 17.4771 4.18944C17.502 4.6826 17.3159 5.16602 16.9663 5.51563Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default PencilIcon;
